const mTableAdvancedServer = {
  unitError: 'Please select site',
  removed: 'Removed successfully',
};

export default mTableAdvancedServer;